module.exports = __webpack_public_path__ + "static/media/britvic.0e42fa49.png";